const productSettings = {
  pageTitle: "Lappa settings",
  backToSettings: "Settings",
  pageHelmetTitle: "Billing history",
  pageTitles: {
    applications: "Applications",
    billings: "Billings",
    plansAndUsage: "Plans & Consumption",
    payments: "Payments",
    sandbox: "Sandbox",
  },
  customerBillingNote:
    "Only your business billing data is shown here (not customer documents).",
  billingDecimalSeparatorHint:
    "Use a dot (.) as the decimal separator, for example 1250.50.",
  mainTabs: {
    applications: "Applications",
    billingHistory: "Billing history",
    plansAndUsage: "Plans & Consumption",
    payments: "Payments",
    sandbox: "Sandbox",
  },
  sandbox: {
    cancel: "Cancel",
    navigation: {
      switchTo: "Switch to sandbox",
      currentSandbox: "Sandbox active",
      switchBack: "Switch back to live company",
      active: "Active sandbox",
      open: "Switch to this sandbox",
      empty: "No sandbox has been created yet.",
      create: "Create sandbox",
      manage: "Manage sandboxes",
      singleLimit: "Only one sandbox can be created for a company.",
    },
    create: {
      configurationTitle: "Starting configuration",
      configurationDescription: "Choose what to include in your new sandbox.",
      copyAccount: "Copy account",
      copyAccountDescription:
        "Settings and capabilities will be modeled after your live account.",
      newSandbox: "Create new sandbox",
      newSandboxDescription: "Nothing will be copied from your live account.",
      next: "Next",
      nameTitle: "Name sandbox",
      nameDescription:
        "We generated a name for you, but feel free to change it now or later.",
      nameLabel: "Sandbox name",
      nameRequired: "Enter a sandbox name.",
      nameTooLong: "Sandbox name must be 80 characters or fewer.",
      regenerate: "Regenerate",
      back: "Back",
      submit: "Create sandbox",
    },
    manage: {
      title: "Manage sandboxes",
      description:
        "Create an isolated environment for testing without changing your live company data.",
      emptyTitle: "No sandbox yet",
      emptyDescription:
        "Create a sandbox to safely test settings and workflows.",
      sandboxDescription: "Isolated from your live company data",
      delete: "Delete sandbox",
      deleteTitle: "Delete sandbox",
      deleteDescription:
        "This sandbox and all of its data will be permanently deleted. This action cannot be undone.",
      deleteActiveHint:
        "Switch back to your live company before deleting this sandbox.",
      created: "Sandbox created successfully.",
      deleted: "Sandbox deleted successfully.",
      retry: "Try again",
    },
  },
  plansAndUsage: {
    innerTabs: {
      overview: "Overview",
      usageAndLimits: "Consumption",
    },
    productFilters: {
      ariaLabel: "Product filter",
      ltax: "L'Tax",
      linvoice: "L'Invoice",
      lepr: "L'EPR",
      lauthorize: "L'Authorize",
      // Legacy key (British spelling) — keep for old sessionStorage / bookmarks
      lauthorise: "L'Authorize",
    },
    emptyProduct: "No active subscription for this product.",
    emptyProductHint: "Choose a plan to start using this product.",
    loading: "Loading plans…",
    subscriptionDrawer: {
      plan: "Plan",
      includedFeatures: "Included features",
      addons: "Add-ons",
      limits: "Limits",
      billing: "Billing",
      billingCycle: "Billing cycle",
      price: "Price",
      changePlan: "Change plan",
    },
    usagePlaceholder: "Consumption — coming soon.",
    usage: {
      periodSwitch: "Usage period",
      monthly: "Monthly",
      yearly: "Yearly",
      coreLimits: "Core limits",
      addonUsage: "Add-on usage",
      creditsTitle: "Credits",
      creditsSubtitle: "Shared across this project",
      remaining: "remaining",
      remainingValue: "{{value}} remaining",
      available: "available",
      used: "used",
      availableUsed: "{{available}} available • {{used}} used",
      percentUsed: "{{percent}}% used",
      footerResetDefault: "Consumption for current subscription period",
      metricSummary: "{{label}} — {{used}} of {{limit}} used ({{percent}}%)",
      daysToRenewal: "{{count}} days to renewal",
      manageSubscription: "Manage subscription",
    },
    overview: {
      subscriptionTitle: "Subscription",
      creditsTitle: "Credits",
      addonsTitle: "Add-ons",
      planDetailsTitle: "Plan details",
      activeBadge: "Active",
      inactiveBadge: "Inactive",
      nextBillingDate: "Next billing date",
      billingCycle: "Billing cycle",
      billingCycleYearly: "Yearly",
      billingCycleMonthly: "Monthly",
      perYear: "/ year",
      perMonth: "/ month",
      perMonthShort: "/mo",
      creditSingular: "credit",
      creditPlural: "credits",
      manageCredits: "Manage credits",
      subscriptionsTitle: "Subscriptions",
      primarySubscription: "Primary subscription",
      otherSubscriptions: "Other subscriptions",
      nextBillingShort: "Next billing",
      billingMetaTotal: "Total",
      billingMetaNextBilling: "Next billing",
      creditsProjectLevel: "Shared across this project",
      summaryProjectLevel: "Project-level totals",
      viewDetails: "View details",
      manageSubscription: "Manage subscription",
      changeSubscription: "Change subscription",
      upgradePlan: "Upgrade plan",
      choosePlan: "Choose plan",
      buyAddons: "Buy addons",
      cancelSubscription: "Cancel subscription",
      canceledStatus: "Canceled",
      planLabel: "Plan",
      statusLabel: "Status",
      priceLabel: "Price",
      createdLabel: "Created",
      includedCountries: "Included countries",
      includedUsers: "Included users",
      vatReturns: "VAT returns",
      statesIncluded: "States included",
      registrationsIncluded: "Registrations",
      autoFiling: "Auto filing",
      includedFeaturesTitle: "Included features",
      subscriptionDetailsTitle: "Subscription details",
      noAddons: "No add-ons on this subscription.",
      noAddonsConnected: "No add-ons",
      oneAddonConnected: "1 add-on connected",
      addonsConnected: "{{count}} add-ons connected",
    addonsColName: "",
    addonsColLimits: "Limits",
    addonsColPeriod: "Period",
    addonsColQuantity: "Quantity",
    addonsColPrice: "Price",
      summaryTitle: "Billing summary",
      monthlyTotal: "Monthly total",
      planCost: "Plan cost",
      addons: "Add-ons",
      addonsTotal: "Add-ons total",
      total: "Total",
    },
  },
  tabs: {
    proforma: "Proforma invoice",
    taxInvoice: "Tax Invoice",
    creditNote: "Credit Note",
    payments: "Payments",
    requestFunds: "Request funds",
    creditsSummary: "Credits summary",
  },
  proforma: {
    addonsLabel: "Add-ons:",
    viewPayment: "View",
  },
  filters: {
    searchPlaceholder: "Search",
    proformaSearchPlaceholder: "Search by invoice number or name",
    dateRangeLabel: "Date range",
    dateFrom: "From",
    dateTo: "To",
    sortByStatus: "Filter by status",
    sortByStatusPrefix: "Sort by status:",
    statusAll: "All",
    showAll: "Show all",
    appsPrefix: "Apps:",
    proformaStatusNew: "New",
    proformaStatusProcessed: "Processed",
    proformaStatusVoided: "Voided",
    proformaStatusRefund: "Refund",
    proformaStatusBalanceRefund: "Balance refund",
    proformaAppLTax: "L'Tax",
    proformaAppLEpr: "L'EPR",
    proformaAppLInvoice: "L'Invoice",
    proformaAppLAuthorize: "L'Authorize",
    advancedFiltersTrigger: "Advanced filters",
    advancedFiltersTitle: "Advanced filters",
    advanced: {
      subscriptionType: "Subscription type",
      subscriptionPlaceholder: "Select subscription",
      addons: "Add-ons",
      addonsPlaceholder: "Select add-ons",
      amount: "Amount",
      amountPlaceholder: "Enter amount",
      optionNone: "\u2014",
      addonMockReports: "Reporting",
      addonMockCompliance: "Compliance",
    },
  },
  filterTabs: {
    moreOptions: "More options",
  },
  statuses: {
    PAID: "Paid",
    PENDING: "Pending",
    OPEN: "Open",
    COMPLETED: "Completed",
    CLOSED: "Closed",
    FAILED: "Failed",
    CANCELLED: "Cancelled",
    paid: "Paid",
    due: "Due",
    credited: "Credited",
  },
  statusFilter: {
    ALL: "All",
    PAID: "Paid",
    PENDING: "Pending",
    OPEN: "Open",
    COMPLETED: "Completed",
    CLOSED: "Closed",
  },
  table: {
    created: "Created",
    invoiceName: "Invoice name",
    creditNoteName: "Credit note name",
    relatedInvoice: "Related invoice",
    number: "Number",
    billingPeriod: "Billing period",
    status: "Status",
    payment: "Payment",
    app: "App",
    amount: "Amount",
    actions: "Actions",
  },
  linkedProformaBanner: {
    label: "Related proforma invoice:",
  },
  linkedPaymentBanner: {
    label: "Related payment:",
  },
  linkedTaxInvoiceBanner: {
    label: "Related tax invoice:",
  },
  contextualPkBanner: {
    clearFilter: "Clear filter",
  },
  billingTableEmpty: {
    title: "No items found",
    proformaTitle: "No items found",
    proformaEmptyDescription: "You currently do not have Proforma invoices",
    requestFundsEmptyDescription: "You currently do not have request funds",
    emptyNoSearch: "You currently do not have {{entity}}.",
    noItemsToDisplay: "There are no items to display.",
    searchNoMatch: 'Your search "{{query}}" did not match any items.',
    filtersNoMatch: "No items match the selected filters.",
    clearSearch: "Clear search",
    clearFilters: "Clear filters",
    entities: {
      _default: "records for this tab",
      PROFORMA: "proforma invoices",
      TAX: "tax invoices",
      CREDIT_NOTE: "credit notes",
      PAYMENTS: "payments",
      REQUEST_FUNDS: "request funds",
      CREDITS_SUMMARY: "credits summary entries",
    },
  },
  loading: "Loading billing history…",
  error: "We could not load billing history. Please try again.",
  retry: "Retry",
  tabsCheckup: {
    noneAvailableTitle: "No billing history available",
    noneAvailableDescription:
      "There are no billing history sections available for this company yet.",
    errorTitle: "Could not load billing history",
    errorDescription:
      "We could not determine which sections are available. Please try again.",
  },
  billingRowActions: {
    viewDetails: "View details",
    view: "View",
    pay: "Pay",
    edit: "Edit",
    void: "Void",
    restore: "Restore",
    download: "Download",
    delete: "Delete",
  },
  taxDownload: {
    error: "Could not download the file. Please try again.",
  },
  proformaDownload: {
    error: "Could not download the file. Please try again.",
  },
  requestFundsDownload: {
    error: "Could not download the file. Please try again.",
  },
  rowActions: {
    download: "Download",
    view: "View details",
    copyNumber: "Copy invoice number",
  },
  requestFunds: {
    addRequestFunds: "Add request funds",
    create: {
      drawerTitle: "Add request funds",
      cancel: "Cancel",
      create: "Create",
      currencyLabel: "Currency",
      requestTypeLabel: "Request type",
      dateLabel: "Date",
      datePlaceholder: "Select date",
      requestNumberLabel: "Request number",
      descriptionLabel: "Description",
      jurisdictionLabel: "Jurisdiction",
      jurisdictionPlaceholder: "Select jurisdiction",
      stateLabel: "State",
      provinceStateLabel: "Province / State",
      stateProvinceLabel: "State / Province",
      statePlaceholder: "Select state / province (optional)",
      stateLoadingPlaceholder: "Loading…",
      requestedAmountLabel: "Requested amount",
      receivedAmountLabel: "Received amount",
      balanceLabel: "Balance",
      statusLabel: "Status",
      statusPendingPayment: "Pending payment",
      statusReceived: "Received",
      statusCompleted: "Completed",
      errorGeneric: "Could not create request funds.",
      errorCurrencyRequired: "Select a currency.",
      errorRequestTypeRequired: "Select a request type.",
      errorDateRequired: "Select a date.",
      errorRequestNumberRequired: "Enter the request number.",
      errorDescriptionRequired: "Enter a description.",
      errorJurisdictionRequired: "Select a jurisdiction.",
      errorAmountRequired: "Enter the amount.",
      errorAmountInvalid: "Enter a valid number.",
      errorStatusRequired: "Select a status.",
      requestDetailsSection: "Request details",
      lineItemsSection: "Line items",
      paymentDetailsSection: "Payment details",
      lineItemDescriptionLabel: "Description",
      lineItemAmountLabel: "Amount",
      addLineItem: "Add line item",
      addItem: "Add item",
      addToList: "Add to list",
      removeLineItem: "Remove line item",
      removeItem: "Remove",
      totalLabel: "Total",
      bankLabel: "Bank",
      bankPlaceholder: "Select bank",
      errorLineItemRequired: "Enter a description.",
      errorLineItemsRequired: "Add at least one line item.",
      errorBankRequired: "Select a bank.",
    },
    filters: {
      sortByStatusPrefix: "Sort by status:",
      statusCompleted: "Completed",
      statusReceived: "Received",
      statusPending: "Pending",
    },
    table: {
      created: "Created",
      description: "Description",
      jurisdiction: "Jurisdiction",
      number: "Number",
      requested: "Requested",
      received: "Received",
      balance: "Balance",
    },
  },
  payments: {
    table: {
      type: "Type",
      reference: "Reference",
      paymentMethod: "Payment Method",
    },
    filters: {
      sortByPaymentMethodPrefix: "Sort by payment method:",
      sortAll: "All",
      sortCard: "Card",
      sortBankTransfer: "Bank transfer",
    },
  },
  paymentsDetails: {
    status: "Status",
    created: "Created",
    number: "Number",
    paymentMethod: "Payment Method",
    amount: "Amount",
    total: "Total",
    sectionTitle: "Payment details",
    colItem: "Item",
    colQty: "Qty",
    colPrice: "Price",
    downloadPdf: "Download PDF",
  },
  paymentsDeleteModal: {
    title: "Delete payment?",
    description:
      "Are you sure you want to delete this payment? This action cannot be undone.",
    cancel: "Cancel",
    delete: "Delete",
  },
  paymentsEdit: {
    drawerTitle: "Edit payment",
    drawerTitleWithNumber: "Edit payment {{number}}",
    cancel: "Cancel",
    save: "Save",
    paymentDateLabel: "Created date",
    paymentDatePlaceholder: "Select payment date",
    paymentNumberLabel: "Payment number",
    pdfLabel: "PDF file",
    replaceFile: "Replace file",
    removeFile: "Remove",
    errorGeneric: "Could not save changes.",
    errorPaymentDateRequired: "Select the payment date.",
    errorNumberRequired: "Enter the payment number.",
    errorSumRequired: "Enter the amount.",
    errorSumInvalid: "Enter a valid amount.",
    errorMissingType: "Payment type is missing; cannot save.",
  },
  creditsSummary: {
    cards: {
      salesTaxAvailable: "Sales Tax credits available",
      salesListAvailable: "Sales list credits available",
    },
    filters: {
      sortByTypePrefix: "Sort by type:",
      sortAll: "All",
      sortSalesTax: "Sales Tax",
      sortSalesList: "Sales List",
    },
    table: {
      description: "Description",
      id: "ID",
      creditType: "Credit Type",
      creditsLeft: "Credits Left",
      amount: "Amount",
    },
  },
  taxInvoiceDetails: {
    status: "Status",
    invoiceDate: "Invoice Date",
    invoiceNumber: "Invoice Number",
    vatNumber: "VAT Number",
    sectionTitle: "Invoice details",
    colItem: "Item",
    colQty: "Qty",
    colPrice: "Price",
    total: "Total",
    downloadPdf: "Download PDF",
  },
  creditNoteDetails: {
    status: "Status",
    createdDate: "Created",
    number: "Number",
    relatedInvoice: "Related invoice",
    sectionTitle: "Credit note details",
    colItem: "Item",
    colQty: "Qty",
    colPrice: "Price",
    total: "Total",
    downloadPdf: "Download PDF",
  },
  proformaInvoiceDetails: {
    title: "Proforma invoice",
    titleWithNumber: "Proforma invoice {{number}}",
    app: "App",
    addonsHeading: "Add-ons",
    noInvoiceDetails: "No invoice details",
  },
  proformaDeleteModal: {
    title: "Delete proforma invoice",
    description:
      "This proforma invoice will be permanently deleted. This action cannot be undone.",
    descriptionWithNumber:
      "Proforma invoice {{number}} will be permanently deleted. This action cannot be undone.",
    cancel: "Cancel",
    delete: "Delete",
  },
  proformaVoidModal: {
    title: "Void proforma invoice?",
    description:
      "This action will mark the proforma invoice as voided. You can restore it later if needed.",
    descriptionWithNumber:
      "Proforma invoice {{number}} will be marked as voided. You can restore it later if needed.",
    cancel: "Cancel",
    void: "Void invoice",
    success: "Proforma invoice voided successfully.",
    errorGeneric: "Could not void this invoice. Please try again.",
  },
  proformaRestoreModal: {
    title: "Restore proforma invoice?",
    description:
      "This action will restore the proforma invoice and set its status back to New.",
    cancel: "Cancel",
    restore: "Restore invoice",
    success: "Proforma invoice restored successfully.",
    errorGeneric: "Could not restore this invoice. Please try again.",
  },
  proformaPayModal: {
    title: "Pay proforma invoice",
    description:
      "Do you want to pay proforma invoice {{number}} from {{date}} for {{amount}}?",
    numberFallback: "—",
    cancel: "Cancel",
    pay: "Pay",
    shopifyPay: "Buy now with Shopify Pay",
  },
  proformaInvoiceEdit: {
    drawerTitle: "Edit proforma invoice",
    cancel: "Cancel",
    save: "Save",
    pdfLabel: "PDF invoice",
    replaceFile: "Replace file",
    removeFile: "Remove",
    errorTitle: "Save failed",
    errorGeneric: "Could not save changes.",
    errorNumberRequired: "Enter the invoice number.",
    errorSumRequired: "Enter the amount.",
    errorSumInvalid: "Enter a valid amount.",
    errorPaymentDateRequired: "Select the payment date.",
    errorUploadAfterSave: "Invoice was saved but the PDF upload failed.",
    createdDateLabel: "Created date",
    createdDatePlaceholder: "Select created date",
    paymentDateLabel: "Payment date",
    paymentDatePlaceholder: "Select payment date",
  },
  mainTabSoon: "Coming soon",
  paymentsSettings: {
    paymentMethod: {
      title: "Payment method",
      subtitle: "This card is used for subscription billing.",
      cardType: "Card type",
      cardNumber: "Card number",
      expirationDate: "Expiration date",
      exp: "Exp",
      expShort: "Exp {{exp}}",
      expLabel: "Exp: {{exp}}",
      cardPreviewLabel: "Saved payment card",
      type: "Type",
      noCardDescription: "No payment method added",
      noCardFooter: "Add a card to enable subscription billing and automatic payments.",
      addCard: "Add card",
      changeCard: "Change card",
      removeCard: "Remove card",
      removeCardError: "Failed to remove card. Please try again.",
      removeCardModal: {
        title: "Remove payment card?",
        description: "This card will no longer be used for subscription billing.",
        confirm: "Remove card",
        cancel: "Cancel",
      },
    },
    priorityCurrency: {
      title: "Priority currency",
      subtitle: "Choose the currency used by default for billing and invoices.",
      saveFailed: "Failed to update priority currency. Please try again.",
    },
    billingContacts: {
      title: "Billing contacts",
      subtitle: "Contact details used on invoices and billing correspondence.",
      edit: "Edit",
      cancel: "Cancel",
      save: "Save",
      saving: "Saving…",
      saveFailed: "Failed to save billing contact. Please try again.",
      selectTaxNumberType: "Select type",
      selectCountry: "Select country",
      noCountries: "No countries found",
      companyName: "Company name",
      country: "Country",
      email: "Email",
      phone: "Phone",
      typeTaxNumber: "Tax number type",
      vatNumber: "Tax number",
      postcode: "Postcode",
      city: "City/Town",
      streetAddress: "Street address",
      address: "Address",
      fieldRequired: "This field is required",
    },
  },
};

export default productSettings;
